import { render } from "./CallListSort.vue?vue&type=template&id=4c0d2db2&ts=true"
import script from "./CallListSort.vue?vue&type=script&lang=ts&setup=true"
export * from "./CallListSort.vue?vue&type=script&lang=ts&setup=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/pages/call/components/CallListSort.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "4c0d2db2"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('4c0d2db2', __exports__)) {
    api.reload('4c0d2db2', __exports__)
  }
  
  module.hot.accept("./CallListSort.vue?vue&type=template&id=4c0d2db2&ts=true", () => {
    api.rerender('4c0d2db2', render)
  })

}


export default __exports__